import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router,} from '@angular/router';
import {CustomerCareService} from '@api/customer-care.service';
import {User} from "@model/user/user.model";

/**
 * SearchResultsComponent
 *
 * @export SearchResultsComponent
 */
@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  /**
   * Used to validate if the searchTerm Changed
   */
  oldSearchTerm: string;

  /**
   * searchTerm from url param
   */
  searchTerm = '';

  /**
   * directorty service search results array
   */
  customerResults: Array<User>;

  /**
   * smartfeed api search results array
   */
  smartFeedCustomerResults: any;

  /**
   * boolean check to see if request has finished
   */
  searchFinished = false;

  /**
   * Creates an instance of SearchResultsComponent.
   *
   * @param router used for route navigation
   * @param route used to get searchTerm from url params
   * @param passThroughService used to get SmartFeed customers
   * @param directoryService used to get ScoopFree customers
   */
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerCareService: CustomerCareService
  ) {
    this.router.events.subscribe((res) => {
      if (res instanceof NavigationEnd) {
        this.setSearchTerm(this.route.snapshot.paramMap.get('term'));
      }
    });
  }

  /**
   * Attempts to set a new searchTerm if it is provided
   *
   * @param searchTerm new value to set searchTerm
   */
  setSearchTerm(searchTerm: string): void {
    this.searchTerm = searchTerm;
    if (this.searchTerm !== this.oldSearchTerm) {
      this.oldSearchTerm = this.searchTerm;
      this.initSearchResults();
    }
  }


  /**
   * Does nothing
   */
  ngOnInit() {}

  /**
   * Initialise the search results
   */
  initSearchResults() {
    if (this.searchTerm) {
      this.customerResults = null;
      this.smartFeedCustomerResults = null;
      this.searchFinished = false;
      this.customerCareService.getAccountByEmail(this.searchTerm).subscribe(
        (value) => {
          this.customerResults = value.data;
          this.searchFinished = true;
        },
        (error) => {
          this.searchFinished = true;
          console.log(error);
        }
      );
    }
  }

  /**
   * viewCustomer
   *
   * @param id id of the selected customer
   */
  viewCustomer(customer: User): void {
    if (customer.userId) {
      const uId =
        customer.userId.split(':').length === 2
          ? customer.userId.split(':')[1]
          : customer.userId;
      this.router.navigate(['customer', uId]);
    }
  }
}
